import IconBack from "./IconBack";
import IconEmail from "./IconEmail";
import IconExternalLink from "./IconExternalLink";
import IconFlip from "./IconFlip";
import IconGithub from "./IconGithub";
import IconLinkedin from "./IconLinkedin";
import IconLogo from "./IconLogo";
import IconLogoInverted from "./IconLogoInverted";
import IconNextSection from "./IconNextSection";

export {
    IconBack,
    IconEmail,
    IconExternalLink,
    IconFlip,
    IconGithub,
    IconLinkedin,
    IconLogo,
    IconLogoInverted,
    IconNextSection
};
